"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ChangeIndicator_meta_1 = require("../ChangeIndicator.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('span', ChangeIndicator_meta_1.CHANGE_INDICATOR_CATEGORY_KEY, ChangeIndicator_meta_1.CHANGE_INDICATOR_COMPONENT_KEY, ['placeholder']);